import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { CommonService } from '../service/common.service';
import { UsersService } from '../service/users.service';
import { MonshinService } from "../service/monshin.service";
import { ShareService } from '../service/share.service';

import { AnswerStatus, Mode, QuestionType } from '../app.constant';
import { Router } from '@angular/router';
import { User } from '../service/users.model';

declare var $;

@Component({
  selector: 'app-b0101-answer',
  templateUrl: './b0101-answer.component.html',
  styleUrls: ['./b0101-answer.component.css']
})
export class B0101AnswerComponent implements OnInit {
  userInfo: any;
  categoryInfo: any;
  settingMonsinInfo:any;
  startQuestionList: any[];
  inspectionList :any[];
  mode: number;
  errorList: any[] = null;
  MODE: any = Mode;
  Q_TYPE: any = QuestionType;
  mendanQuestionList: any[];

  constructor(
    private commonService: CommonService,
    private usersService: UsersService,
    private monshinService: MonshinService,
    private router: Router,
    private shareService: ShareService,
    private location: Location) { }

    
  /*特建の質問を持っているかどうか*/
  hasSpQuestion():boolean{
    var checkRow = this.startQuestionList.filter(
      item => 
      item.m_question_type_id ==6 || item.m_question_type_id ==7
    );  
    if (checkRow.length==0){
      return false;
    }else{
      return true;
    }
  }
  /*特建の選択リストを構成する*/
  SpAnswerList(id){
    var checkRow = this.startQuestionList.filter(
      item => 
      item.m_question_type_id ==id
    );  

    if (checkRow.length==0){
      return null;
    }else{
      return checkRow["0"].t_result_list.t_result_id_list;
    }
  }

  /*化学物質全件表示切替*/
  chemical_alldisp_change(){
    this.settingMonsinInfo.chemical_alldisp = !this.settingMonsinInfo.chemical_alldisp;
  }
  /*有機溶剤全件表示切替*/
  organic_alldisp_change(){

    this.settingMonsinInfo.organic_alldisp = !this.settingMonsinInfo.organic_alldisp;
  }

  ngOnInit() {
    //component読み込みのため、スクロール位置を固定で一番上に
    window.scrollTo(0, 0);

    this.categoryInfo = this.shareService.getCategoryInfoShare();
    if (this.categoryInfo != null) {
      this.mode = this.shareService.getModeShare();
      //この画面の情報を保持していなければDBから取得
      this.startQuestionList = this.shareService.getStartQuestionListShare();
	    this.userInfo = this.usersService.userinfo;
      this.settingMonsinInfo = this.shareService.getSettingMonsinInfo();
      if(this.startQuestionList == null)this.getStartQuestionList();
      // if(this.categoryInfo['hiro_flg'] == 1 || this.categoryInfo['suimin_flg'] == 1){
      //   this.getMendanStartQuestionList()
      //   this.startQuestionList = null
      // }else{
      //   this.getStartQuestionList();
      // }
      //保持しているメインの質問データを破棄 -> 再取得をさせるため
      this.shareService.refleshQuestionListShare();
    } else {
      this.commonService.modalOpens(90001, modalresult => {
        this.router.navigate(["/home"]);
      });
    }
  }
  getStartQuestionList(): void {
    //0102と同じようにparamsを作成しGetに投げる処理の実装
    let params = {
      "t_person_id": this.categoryInfo["t_person_id"],
      "t_event_id": this.categoryInfo["t_event_id"],
      "t_question_category_id": this.categoryInfo["t_question_category_id"],
      "m_question_category_id": this.categoryInfo["m_question_category_id"],
      "m_language_id": this.categoryInfo["m_language_id"],
    };

    this.monshinService.getStartQuestionList(params)
      .subscribe((res: Response) => {

        if (res["fuel_status"] == "OK") {
          //questionListが0レコードならエラー
          this.startQuestionList = res["fuel_results"]["question_list"] != null ? res["fuel_results"]["question_list"] : [];

          this.shareService.refleshSettingMonsinInfo();
          this.settingMonsinInfo = this.shareService.getSettingMonsinInfo();

          this.shareService.setInitialStartQuestionListShare(JSON.parse(JSON.stringify(this.startQuestionList)));
          //基本質問がなければメインの質問にスキップ
          if (this.startQuestionList.length == 0) {
            this.shareService.setStartResultListShare([]);
            this.router.navigate(["/answer/main"]);
          }

        }else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
        }else{
            this.commonService.modalOpens(11003,modalresult=>{});
        }
    },error => {
        this.commonService.modalOpens(error,modalresult=>{});
    });
  }

  onSubmit(temp) {

    //shareにあるエラーリストを初期化
    this.shareService.refleshErrorListShare();
    //shareにある検査項目リストを初期化
    this.shareService.refleshInspectionListShare();


    //基本情報の登録用データを生成
    let startResultList = [];
    //基本質問はすべての質問を表示するため、固定でshow=true
    this.monshinService.createResultData(startResultList, this.startQuestionList, true);
    //バリデーションチェック後のエラーリストが１レコードでもあれば、処理中断
    this.errorList = this.shareService.getErrorListShare();
    if (this.errorList != null) {
      //TOPに戻る
      window.scrollTo(0, 0);
      return;
    }

    //基本質問に６と７があれば
    if(this.hasSpQuestion()){
      let param={
        chemcal_list :this.SpAnswerList(6),
        organic_list :this.SpAnswerList(7)
      };
      this.monshinService.getInspectionList(param)
      .subscribe((res: Response) => {
          if (res["fuel_status"] == "OK") {
            this.inspectionList = res["fuel_results"];
            //検査項目リストの保持
            this.shareService.setInspectionListShare(this.inspectionList);
            //質問データの保持
            this.shareService.setStartQuestionListShare(this.startQuestionList);
            //結果データの保持
            this.shareService.setStartResultListShare(startResultList);

            //メインの質問画面に遷移
            this.router.navigate(["/answer/main"]);
              
          }else if (res["fuel_status"] == "NG") {
            this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
          }else{
              this.commonService.modalOpens(11003,modalresult=>{});
          }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }else{
      this.inspectionList = [];
      //検査項目リストの保持
      this.shareService.setInspectionListShare(this.inspectionList);
    //質問データの保持
    this.shareService.setStartQuestionListShare(this.startQuestionList);
    //結果データの保持
    this.shareService.setStartResultListShare(startResultList);

    //メインの質問画面に遷移
    this.router.navigate(["/answer/main"]);
    }

  }

  goBack(): void {
    this.router.navigate(["/home"]);
  }

  selectP(p: string): void {
    $('html,body').animate(
      { scrollTop: $(`#qid${p}`).offset().top }
    );
  }

  getMendanStartQuestionList(): void {
    let params = {
      "t_person_id": this.categoryInfo["t_person_id"],
      "t_event_id": this.categoryInfo["t_event_id"],
      "t_yoyaku_id": this.categoryInfo["t_yoyaku_id"],
      "t_addition_question_category_id": this.categoryInfo["t_addition_question_category_id"],
      "m_language_id": this.categoryInfo["m_language_id"]

    };

    this.monshinService.getMendanStartQuestionList(params)
      .subscribe((res: Response) => {
        this.mendanQuestionList = [];
        if (res["fuel_status"] == "OK") {
          //questionListが0レコードならエラー
          this.mendanQuestionList = res["fuel_results"]["question_list"] != null ? res["fuel_results"]["question_list"] : [];

          this.shareService.refleshSettingMonsinInfo();
          this.settingMonsinInfo = this.shareService.getSettingMonsinInfo();

          this.shareService.setInitialStartQuestionListShare(JSON.parse(JSON.stringify(this.mendanQuestionList)));
          //基本質問がなければメインの質問にスキップ
          if (this.mendanQuestionList.length == 0) {
            this.shareService.setStartResultListShare([]);
            this.router.navigate(["/answer/main"]);
          }
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(res["fuel_message"], modalresult => { });
        } else {
          this.commonService.modalOpens(11003, modalresult => { });
        }
        //質問データの保持
        this.shareService.setStartQuestionListShare(this.mendanQuestionList);
      }, error => {
        this.commonService.modalOpens(error, modalresult => { });
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/b0101-answer/b0101-answer.component.ts